<template>
  <div class="relative flex flex-col gap-3">
    <div class="absolute w-5 left-0 top-0 h-full flex justify-center">
      <div
        class="h-[calc(100%-2.2rem)] border border-gray-300 absolute bottom-2"
      ></div>
    </div>
    <!-- {{ deliveryToUse }} -->
    <div
      class="flex items-start gap-2 relative"
      :class="{
        'text-primary font-bold': !deliveryToUse?.pickupReached,
        'text-gray-400': deliveryToUse?.pickupReached,
        'line-through': !noLineThrough && deliveryToUse?.pickupReached,
      }"
    >
      <div class="w-5 h-5 min-w-5 flex items-center justify-center mt-0.5">
        <ColorImg
          src="/images/icons/location.png"
          class="w-5 h-5 bg-current"
        ></ColorImg>
      </div>
      <div :class="{ truncate }">
        <template
          v-if="deliveryToUse?.pickupLabel && deliveryToUse?.pickupAddress"
        >
          <div>
            {{ deliveryToUse?.pickupLabel }}, {{ deliveryToUse?.pickupAddress }}
          </div>
        </template>
        <template v-else-if="deliveryToUse?.pickupLabel">
          {{ deliveryToUse?.pickupLabel }}
        </template>
        <template v-else-if="deliveryToUse?.pickupAddress">
          {{ deliveryToUse?.pickupAddress }}
        </template>
        <!-- Description de localisation du pickup (indications pour le rider) -->
        <div
          v-if="deliveryToUse?.pickupInstructions"
          class="text-md font-normal mt-0.5 "
          :class="{ 'line-clamp-2': truncate }"
        >
          📍 {{ deliveryToUse?.pickupInstructions }}
        </div>
      </div>
    </div>
    <div
      class="flex items-start gap-2 relative"
      v-for="(checkpoint, i) in deliveryToUse?.checkpoints || []"
      :key="i"
      :class="{
        'text-primary font-bold':
          !checkpoint?.delivered && checkpoint?.previousDelivered,
        'text-gray-900': !checkpoint?.previousDelivered,
        'text-gray-400': checkpoint?.delivered,
        'line-through': !noLineThrough && checkpoint?.delivered,
      }"
    >
      <div class="w-5 h-5 min-w-5 flex items-center justify-center mt-0.5">
        <div class="w-2.5 h-2.5 bg-current rounded-full"></div>
      </div>
      <div :class="{ truncate }">
        <template v-if="checkpoint?.address">
          {{ checkpoint?.address }} -
        </template>
        {{ checkpoint?.label }}
        <!-- Description de localisation du checkpoint (indications pour le rider) -->
        <div
          v-if="checkpoint?.instruction"
          class="text-md font-normal mt-0.5 "
          :class="{ 'line-clamp-2': truncate }"
        >
          📍 {{ checkpoint?.instruction }}
        </div>
        <!-- Contact du checkpoint (visible uniquement en vue complète) -->
        <div
          v-if="!truncate && (checkpoint?.customerName || checkpoint?.customerPhoneNumber)"
          class="mt-1 flex items-center gap-2 flex-wrap"
        >
          <span v-if="checkpoint?.customerName" class="text-sm font-normal opacity-80">
            {{ checkpoint?.customerName }}
          </span>
          <a
            v-if="checkpoint?.customerPhoneNumber"
            :href="`tel:${checkpoint?.customerPhoneNumber}`"
            class="text-sm font-bold text-primary underline flex items-center gap-1"
            @click.stop
          >
            📞 {{ checkpoint?.customerPhoneNumber }}
          </a>
        </div>
      </div>
    </div>
    <div
      class="flex items-start gap-2 relative"
      :class="{
        'text-primary font-bold':
          !deliveryToUse?.destinationReached &&
          deliveryToUse?.checkpointsReached,
        'text-gray-900': !deliveryToUse?.checkpointsReached,
        'text-gray-400': deliveryToUse?.destinationReached,
        'line-through': !noLineThrough && deliveryToUse?.destinationReached,
      }"
    >
      <div class="w-5 h-5 min-w-5 flex items-center justify-center mt-0.5">
        <div class="w-3 h-3 bg-current rounded-full"></div>
      </div>
      <div :class="{ truncate }">
        <template v-if="deliveryToUse?.destinationAddress">
          {{ deliveryToUse?.destinationAddress
          }}<template v-if="deliveryToUse?.destinationLabel"> - {{ deliveryToUse?.destinationLabel }}</template>
        </template>
        <template v-else>
          {{ deliveryToUse?.destinationLabel }}
        </template>
        <!-- Description de localisation de la destination (indications pour le rider) -->
        <div
          v-if="deliveryToUse?.destinationInstructions"
          class="text-md font-normal mt-0.5 "
          :class="{ 'line-clamp-2': truncate }"
        >
          📍 {{ deliveryToUse?.destinationInstructions }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ColorImg from '@/presentation/components/img/ColorImg.vue'
import { computed, watch, ref } from 'vue'

const props = defineProps({
  delivery: { type: Object, default: null },
  useOldOnNull: { type: Boolean, default: true },
  noLineThrough: { type: Boolean, default: false },
  truncate: { type: Boolean, default: false },
})

const prevData = ref({ d: 'd' })
const deliveryProps = computed(() => props.delivery)
const deliveryToUse = computed(
  () => props.delivery || (props.useOldOnNull ? prevData.value : null),
)

watch(
  deliveryProps,
  (newVal, prev) => {
    prevData.value = prev
  },
  { deep: true },
)
</script>
